import { BaseControler } from "@/lib/track/controler/base-controler";
import type { LaneOrigin } from "@/lib/track/controler/controler";
import type { Lane } from "@/lib/track/lane";

/**
 * Une piste faite d'une lane déjà construite.
 *
 * Les autres contrôleurs *fabriquent* leurs lanes : le morceau les tire de sa
 * partition, le live les crée à l'arrivée d'un partenaire. Celui-ci n'en
 * fabrique aucune — il présente une lane que la session tient déjà, et qui doit
 * lui survivre. C'est ce qui permet à la lane du piano d'être mémorisée avec sa
 * session : on la retrouve avec ses notes et son synthé chaud en revenant,
 * alors que la piste, elle, est remontée à chaque activation.
 *
 * D'où l'absence de `destroy` qui toucherait à la lane : elle n'appartient pas
 * à ce contrôleur.
 */
export class LaneControler extends BaseControler {
  constructor(
    private readonly lane: Lane,
    private readonly origin: LaneOrigin,
    public label?: string,
  ) {
    super();
  }

  start(): void {
    this.emit("lane:created", this.lane);
  }

  getLaneOrigin(lane: Lane): LaneOrigin | undefined {
    if (lane === this.lane) {
      return this.origin;
    }

    return undefined;
  }
}
